/* eslint-disable jsx-a11y/no-noninteractive-element-interactions,jsx-a11y/anchor-has-content,no-unused-vars,react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  changeFieldAvatarFile,
  sendRequest,
  selectRequestState,
  initState,
  deleteAvatar
} from 'mt-react-common/modules/users/common/reducers/forms/avatarForm';
import { withRouter } from 'react-router-dom';
import { selectAvatarPath } from 'mt-react-common/modules/users/common/reducers/states/authAccount';
import { t } from 'utils/translates';
import OpacityPreLoader from '../../Common/PreLoaders/OpacityPreLoader';

const authAccountRN = 'usersModule.forms.avatarForm';

class UserChangeAvatarReportPop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileUrlFromUploaded: '',
      file: null // Можно тут хранить файлы, управлять ими, выводить их в представлении до отправки на сервер
    };
    this.props.initState();
  }
  componentDidMount() {
    // eslint-disable-next-line no-undef
    $('#avatarPopUp').modal('show');
  }

  componentDidUpdate() {
    if (this.props.requestState.hasSuccessQuery) {
      this.close();
    }
  }

  close = () => {
    // eslint-disable-next-line no-undef
    $('#avatarPopUp').modal('hide');
    // eslint-disable-next-line no-undef
    $('#avatarPopUp').on('hidden.bs.modal', () => {
      this.context.router.history.goBack();
    });
  };

  closeHandler = event => {
    event.preventDefault();
    this.close();
  };

  handleUploadFilesByUrl = () => {
    this.props.changeFieldAvatarFile([this.state.fileUrlFromUploaded]);
    this.props.sendRequest();
  };

  handleUploadFiles = file => {
    this.setState({ file });
    this.props.changeFieldAvatarFile(file);
  };

  render() {
    return (
      <div
        className="modal modal-gray fade"
        data-toggle="modal"
        data-backdrop="static"
        data-keyboard="false"
        id="avatarPopUp"
        role="dialog"
        aria-labelledby="myModalLabel"
        onClick={this.closeHandler}
      >
        <div
          className="modal-dialog"
          role="document"
          onClick={e => e.stopPropagation()}
        >
          <div className="modal-content">
            <div className="modal-header text-center">
              <a
                aria-label="Close"
                className="close close-black"
                href=""
                onClick={this.closeHandler}
              />
              <h2 className="modal-title h4">
                <i className="fa fa-camera" /> {t('Загрузка новой фотографии')}
              </h2>
            </div>
            <div className="modal-body">
              {this.props.requestState.hasInProgress ? (
                <OpacityPreLoader />
              ) : null}
              <div className="form-group m-b-0">
                <div className="control-group">
                  <div className="fileupload fade dropzone">
                    <span className="fileupload-title">
                      <i className="fa fa-picture-o" />
                      &nbsp;{t('Загрузить Фото с компьютера')}
                    </span>
                    <input
                      id="inputAddImg"
                      type="file"
                      onChange={e => this.handleUploadFiles(e.target.files[0])}
                    />
                  </div>
                  <p className="text-center">{t('или')}</p>
                  <div className="input-group">
                    <input
                      className="form-control ng-pristine ng-valid ng-touched"
                      name="formImgAddUrl"
                      placeholder={t('Скопировать URL изображения')}
                      type="text"
                      value={this.state.fileUrlFromUploaded}
                      onChange={e =>
                        this.setState({ fileUrlFromUploaded: e.target.value })
                      }
                    />
                    <span className="input-group-btn">
                      <button
                        className="btn btn-default"
                        type="button"
                        onClick={this.handleUploadFilesByUrl}
                      >
                        {t('Сохранить')}
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-body bg-main border-simple-t">
              <div className="bg-sub text-center p-t-30 p-b-30">
                {this.state.file ? (
                  <img
                    alt=""
                    src={URL.createObjectURL(this.state.file)}
                    height="200"
                  />
                ) : (
                  <img
                    alt=""
                    className="img-responsive center-block"
                    id="preview"
                    width="200px"
                    src={this.props.avatarPath}
                  />
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-default pull-left"
                type="button"
                onClick={this.props.deleteAvatar}
              >
                {t('Удалить изображение')}
              </button>
              <button
                className="btn btn-muted"
                type="button"
                onClick={this.closeHandler}
              >
                {t('Отмена')}
              </button>
              <button
                className="btn btn-primary"
                type="button"
                onClick={this.props.sendRequest}
              >
                {t('Сохранить')}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

UserChangeAvatarReportPop.contextTypes = {
  router: PropTypes.shape()
};

UserChangeAvatarReportPop.propTypes = {
  // IN
  // CONNECT
  requestState: PropTypes.shape({
    hasInProgress: PropTypes.bool.isRequired,
    hasSuccessQuery: PropTypes.bool
  }).isRequired,
  initState: PropTypes.func.isRequired,
  changeFieldAvatarFile: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired,
  avatarPath: PropTypes.string.isRequired,
  deleteAvatar: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  requestState: selectRequestState(state, authAccountRN),
  avatarPath: selectAvatarPath(state, authAccountRN)
});

const mapDispatchToProps = (dispatch, props) => ({
  initState: () => dispatch(initState(authAccountRN)),
  changeFieldAvatarFile: value =>
    dispatch(changeFieldAvatarFile(authAccountRN, value)),
  sendRequest: () => dispatch(sendRequest(authAccountRN)),
  deleteAvatar: () => dispatch(deleteAvatar(authAccountRN))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(UserChangeAvatarReportPop)
);



// WEBPACK FOOTER //
// ./src/components/UserAccount/UserChangeAvatarReportPop/UserChangeAvatarReportPop.js